import React from 'react';
import type { PortableTextBlock as PortableTextBlockType } from '@sanity/types';
import { PortableText, PortableTextComponents } from '@portabletext/react';
import { bgColorClassname } from '@/utils';
import { Link } from '@/components';
import { LinkInterface } from '@/types';

interface CalloutProps {
  backgroundColor?: {
    label: string;
    value: string;
  };
  content: PortableTextBlockType;
  isTextFullWidth: boolean;
  includeCta: boolean;
  cta?: LinkInterface | undefined;
}

// Define custom Portable Text components
const customComponents: PortableTextComponents = {
  marks: {
    strong: ({ children }) => <strong className='font-semibold text-yellow-500'>{children}</strong>,
  },
};

const Callout: React.FC<CalloutProps> = ({
  backgroundColor,
  content,
  isTextFullWidth,
  includeCta,
  cta,
}) => {
  return (
    <div className={`${backgroundColor ? bgColorClassname(backgroundColor) : ''} h-full `}>
      <div
        className={`font-halyarddisplay mx-auto  h-full max-w-screen-xl items-center bg-[url("/images/round-shape-big.svg")] bg-[length:150px_150px] bg-no-repeat px-5 pb-16 [background-position:left_calc(100%_+_75px)] md:flex md:gap-x-6 md:px-[50px] md:pb-14 lg:gap-x-12 xl:gap-x-24 ${isTextFullWidth == true ? 'pt-8 md:pt-9' : 'pt-8 md:pt-11'}`}
      >
        <div className={`w-full text-xl text-white`}>
          <div className='hide-br inline-block text-2xl font-semibold lg:block lg:text-4xl'>
            <div className='text-right'>
              <img
                src='/images/highlight-pattern.svg'
                className={`ml-auto max-h-14 lg:max-h-[100px] ${isTextFullWidth == true ? '-mb-2 lg:-mr-4' : '-mb-4 lg:-mb-[60px]'}`}
                alt='Highlight Pattern'
              />
            </div>
            <div
              className={`flex flex-wrap items-center gap-x-1 leading-none md:block ${isTextFullWidth == true ? '-mr-px mb-7' : ''}`}
            >
              <PortableText
                value={content}
                components={customComponents}
              />
            </div>
          </div>
          {includeCta && cta && (
            <div className='mb-12 mt-0'>
              <img
                src='/images/doodle.png'
                className='mb-0 ml-auto mr-14 h-6'
                alt='doodle'
              />
              <Link
                {...cta}
                variant='outline'
                size='sm'
                className='w-full border-white text-white'
              >
                {cta.label}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Callout;
